// Tier-3 builder presentation seam (Phase 7A).
//
// The Workout Builder's tempo field. Presentation only: the container keeps
// `tempoDrafts`, the 0-5 digit filtering, the four-digit normalization and the
// commit-on-blur suppression. This component renders the input and forwards the
// three events, nothing else.
export default function TempoControl({
  value,
  disabled = false,
  id,
  ariaLabel,
  onFocus,
  onChange,
  onBlur,
}) {
  return (
    <input
      type="text"
      inputMode="numeric"
      disabled={disabled}
      value={value}
      id={id}
      aria-label={ariaLabel}
      onFocus={onFocus}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onBlur}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.currentTarget.blur();
        }
      }}
      className="lz-builder-field lz-builder-field--tempo"
    />
  );
}
